import React from 'react';

export default class Configuracao extends React.Component {
  render() {
    return (<h1 data-testid="settings-title">     Configurações</h1>);
  }
}
